<script>

export default {
  name: 'RulesOfStreamers'
}
</script>

<template lang="pug" src="./RulesOfStreamers.pug"></template>
